import { createFileRoute } from "@tanstack/react-router";
import { MatchPreviewPage } from "../../components/match";

export const Route = createFileRoute("/match/")({
    component: MatchPreviewPage,
});
